import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'

import styles from './styles.module.css'

function Subtitle({children, type = 'main'}) {
  const className = styles[type]

  return <p className={className}>{children}</p>
}

Subtitle.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node.isRequired
}

export default withStyles(styles)(Subtitle)
